import { gicSmartFieldsFeatureResource } from '@atlassian/jira-router-resources-gic-smart-fields/src/services/index.tsx';
import { useResource } from '@atlassian/react-resource-router';

export const useSmartFieldsPreferenceResource = () => useResource(gicSmartFieldsFeatureResource);

export const useSmartFieldsMachineLearning = () => {
	const { loading: loadingJiraLabsSmartFields, data: jiraLabsSmartFieldsData } =
		useSmartFieldsPreferenceResource();

	const hasUserOptedOut = jiraLabsSmartFieldsData?.hasUserOptedOut;

	const withMachineLearning = !loadingJiraLabsSmartFields && !hasUserOptedOut;

	return {
		withMachineLearning,
	};
};
